import { Injectable } from '@angular/core';
import { BaseAPIClass } from '@app/core/class/baseAPI.class';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment.prod';
import { Order } from '../model/order.model';
import { Paginated } from '../model/paginated.model';

@Injectable()
export class PagoService extends BaseAPIClass {
  baseUrl = environment.serverBaseUrl;
  public isLoading = false;
  constructor(protected httpClient: HttpClient, handler: HttpBackend) {
    super(httpClient);
    this.httpClient = new HttpClient(handler);
    this.baseUrl = this.baseUrl + '/pagos';
  }

  listarPagos(id: string) {
    return this.httpClient.get(this.baseUrl + '/venta/' + id);
  }

  realizarPago(object: any) {
    return this.httpClient.post(this.baseUrl, object);
  }

  /* getExistencia(obje){

  }*/
}
